import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { routes } from ".";
import { localStorageItemNames } from "../common/constants";
import { Cookies } from "react-cookie";

const ProtectedRoute = ({  children, guestOnly = false }) => {

    const cookies = new Cookies();
    const token = cookies.get(localStorageItemNames.TOKEN);

    if (guestOnly) {
        if (token) {
            return <Navigate to={routes.DASHBOARD} replace />;
        }
        return children;
    }

    if (!token) {
        return <Navigate to={routes.LOGIN} replace />;
    }

    return children;
};

ProtectedRoute.propTypes = {
    children: PropTypes.node,
    guestOnly: PropTypes.bool,
};

export default ProtectedRoute;
